















/* tslint:disable */
    import { Vue, Component, Prop } from 'vue-property-decorator';
    import * as moment from 'moment-timezone';
    import { mapState } from 'vuex';
    import { StoreState } from '../../../store';
    

 @Component({
  computed: {
            ...mapState({
                  'weeklyEnabled': (state: StoreState) => state.reports.scheduleForm.weeklyEnabled,
                'dailyEnabled': (state: StoreState) => state.reports.scheduleForm.dailyEnabled,
                'dailyTime': (state: StoreState) => state.reports.scheduleForm.dailyTime,
                 'monthlyEnabled': (state: StoreState) => state.reports.scheduleForm.monthlyEnabled,
                 'weeklyTime': (state: StoreState) => state.reports.scheduleForm.weeklyTime,
                 'monthlyTime': (state: StoreState) => state.reports.scheduleForm.monthlyTime,
              
                
            }),
           
        }
  } )
    export default class TimeSelector extends Vue {
      
        @Prop() tag!: string;
        @Prop() isDisabled!: boolean;

        time!: Date|number;
        meridians: string[] = ['PM', 'AM'];
        meridian: string = 'PM';
        hours: string[] = ['1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00','10:00','11:00','12:00'];
        hour: string = '';
        weeklyTime!:       Date;
        dailyTime!:        Date;
        monthlyTime!:      Date;
        dailyEnabled!:     boolean;
        weeklyEnabled!:    boolean;
        monthlyEnabled!:   boolean;

        mounted() {
          //  alert(this.dailyTime);
          var settimevalue:Date;
          if (this.dailyEnabled)
            settimevalue= this.dailyTime;
         else if (this.weeklyEnabled)
            settimevalue= this.weeklyTime;
         else if (this.monthlyEnabled)
            settimevalue= this.monthlyTime;

          if (!this.isDisabled)
            this.setTime(settimevalue);
           
            this.updateTime();
        }

        public setTime(dailyTime)  
        {
            
            var t_hour= !dailyTime ? 0:(dailyTime as Date).getHours() ;
            if (t_hour===0 && (dailyTime==-1 || dailyTime==null) )
            {
                this.hour='';
            }
            if(t_hour===0 && dailyTime!=-1  &&  dailyTime!=null){
                 this.hour='12:00';
                 this.meridian='AM';  
            }
           else if (t_hour>11)
            {
                this.hour=`${t_hour-12}:00`;
                this.hour=this.hour=='0:00'?'12:00':this.hour;
                this.meridian='PM';   
            }   
            else
            {
                this.hour=`${t_hour}:00`;
                this.meridian='AM';
            }
        }

        updateTime(hour = null, meridian = null) {
            if (hour !== null) {
                (this as any).hour = hour;
            }
            if (meridian !== null) {
                (this as any).meridian = meridian;
            }
            if (this.hour) {
                (this as any).time = this.valuesToTime(this.hour, this.meridian);
            } else {
                this.time = -1;
            }
            this.$emit('timeChange', this.time);
        }

        // May wish to move these to a time service so the parent controller can initialize Date values
        //  by using the service.
        valuesToTime (hour: string, meridian: string): Date {
            const calendarstr = new Date( Date.now() ).toISOString().slice(0,10);
            const timestr = ` ${hour} ${meridian}`;
            const datetime = moment(calendarstr + timestr, 'YYYY-MM-DD h:m a');
            return datetime.toDate();
        }
    }
